// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueMeta from 'vue-meta';

Vue.use(VueMeta);

Vue.config.productionTip = false

// utils
import utils from '@/utils/utils';
Vue.prototype.utils = utils;

import request from '@/utils/request';
Vue.prototype.req = request;

import {decrypt}  from '@/utils/crypto';

Vue.prototype.$decrypt = decrypt;

import "@/styles/common.scss";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js